import type { HelpFile } from '../../types/help'
import { SectionCardTestIds } from '../../../testids/SectionCardTestIds'

export const sectionCardHelp: HelpFile = {
  docPage: '/docs/admin/form-layout-designer',
  texts: {
    [SectionCardTestIds.sectionLabelBtn]:
      'Edit the label shown above this section in the rendered form.',
    [SectionCardTestIds.sectionColumnsSelect]:
      'Choose how many columns this section uses to lay out its fields.',
    [SectionCardTestIds.sectionDeleteBtn]:
      'Delete this section and all the fields it contains. This action cannot be undone.',
  },
}
